// extracted by mini-css-extract-plugin
export default {"detail_container_top":"Detail_detail_container_top__5pU7s","detail_container_bottom":"Detail_detail_container_bottom__YpfCf"};